export default "__VITE_ASSET__9hCPloGH__"